// actually set for header and footer to calculate height on the given element
export function distanceCalculation() {
    const distanceCalculations = document.querySelectorAll<HTMLElement>(
        "[data-distance-calculation]",
    );

    if (distanceCalculations.length > 0) {
        const root = document.querySelector<HTMLElement>(":root");
        distanceCalculations.forEach((distanceCalculation) => {
            new ResizeObserver(function () {
                // @ts-ignore
                root.style.setProperty(
                    `--complex-${distanceCalculation.dataset.distanceCalculation}-height`,
                    `${distanceCalculation.offsetHeight}px`,
                );
            }).observe(distanceCalculation);
        });
    }
}
